import { createFileRoute } from '@tanstack/react-router';
import { LearnArticleDetail } from '~/components/sections/LearnArticleDetail';
import { learnArticleHeadMeta, loadLearnArticle } from '~/lib/learn-article-route';

export const Route = createFileRoute('/pakistan/$slug')({
  loader: ({ params }) => loadLearnArticle('pakistan', params.slug),
  head: ({ loaderData }) => learnArticleHeadMeta(loaderData?.article),
  component: PakistanArticlePage,
});

function PakistanArticlePage() {
  const { article } = Route.useLoaderData();
  return <LearnArticleDetail key={article.fullPath} article={article} />;
}
